import { DocumentState, DOCUMENT_FILTERS } from './document.state';

export type DocBoxState = Readonly<{
    docBoxFiles: DocumentState[];
    isAllFilesSelected: boolean;
    isLoading: boolean;
    filters: { [key in DOCUMENT_FILTERS]: string };
    sortByField: {
        field: keyof DocumentState;
        ascending: boolean;
    };
}>;

export const initialDocBoxState: DocBoxState = {
    docBoxFiles: [],
    isAllFilesSelected: false,
    isLoading: false,
    filters: {
        docType: '',
        title: '',
        printNumber: '',
        date: '',
        createdBy: '',
        orderNumber: '',
        reportStatus: '',
        fileType: '',
    },
    sortByField: {
        field: 'date',
        ascending: false,
    },
};
